define((require) => {
    "use strict";

    var _                    = require("underscore"),
        CustomJsLockIconView = require("editor/ui/settings/integrations/customJs/lockIcon/CustomJsLockIconView"),
        EditorEvents         = require("shared/services/EditorEvents"),
        ImprovedView         = require("editor/zbone/ImprovedView"),
        Permissions          = require("shared/security/Permissions"),
        template             = require("editor/ui/settings/integrations/customJs/CustomJsItemView.tpl"),
        Tooltip              = require("ui/common/Tooltip");

    return ImprovedView.extend("CustomJsItemView", {

        template: template,

        tagName: "li",

        className: "custom-js-item",

        templateHelpers: function() {
            return {
                readOnly: this._readOnly
            };
        },

        _readOnly: null,

        ui: {
            title: ".title",
            wrapper: ".item-wrapper",
            remove: ".delete-icon"
        },

        regions: {
            lockRegion: ".lock-region"
        },

        events: {
            "click @ui.wrapper": "_wrapperClickHandler",
            "click @ui.remove":  "_delete"
        },

        bindings: {
            ".title": "action.name"
        },

        initialize: function() {
            this._readOnly = this.model.get("actionIsInUse") || Permissions.Roles.MANAGER.cannot();
        },

        onShow: function() {
            var tooltipContent = null;

            if (Permissions.Roles.MANAGER.cannot()) {
                tooltipContent = "You do not have permission to delete this custom action.";
            } else if (this.model.get("actionIsInUse")) {
                // Show lock icon
                this.lockRegion.show(new CustomJsLockIconView({
                    ids: this.model.get("action").get("usedBy")
                }));

                tooltipContent = "This action cannot be deleted because it is in use.";
            }

            if (tooltipContent !== null) {
                Tooltip.add(this.ui.remove, {
                    content: tooltipContent,
                    placement: "top",
                    width: 200
                });
            }
        },

        _delete: function() {
            if (!this._readOnly) {
                this.trigger("delete");

                var action = self.model.get("action"),
                    parameters = _.keys(action.get("parameters")).join(),
                    eventProperties = {
                        category: "Commerce",
                        actionName: action.get("name"),
                        actionParameters: parameters,
                        integrationType: "CustomJS",
                        triggerOrigin: "DeleteCustomJSButton"
                    };

                EditorEvents.trigger(EditorEvents.constants.DELETE_INTEGRATION, eventProperties);
            }
        },

        _wrapperClickHandler: function(event) {
            // Only trigger the edit if the container or the title was clicked, and thus not if the
            // lock or the delete icon was clicked.
            if (event.target === this.ui.wrapper[0] || event.target === this.ui.title[0]) {
                this.trigger("edit");
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/customJs/CustomJsItemView.js